import React from "react";
import { Loader2 } from "lucide-react";
import Tooltip from "components/ui/Tooltip";

const TONES = {
  default: "border-border bg-surface text-text_secondary",
  primary: "border-border bg-primary_tint text-primary",
  danger: "border-danger_border bg-danger_bg text-danger",
};

// Square icon button with a tooltip, used for the row actions of every Reminder Setup list.
export default function IconAction({ label, icon: Icon, onClick, tone = "default", busy = false, disabled = false }) {
  return (
    <Tooltip content={label}>
      <button
        type="button"
        aria-label={label}
        disabled={busy || disabled}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        className={`inline-flex h-7 w-7 items-center justify-center rounded-md border disabled:opacity-50 ${TONES[tone] || TONES.default}`}
      >
        {busy ? <Loader2 size={13} className="animate-spin" /> : <Icon size={13} />}
      </button>
    </Tooltip>
  );
}
